import axios from "@/config/axios";

const initiateState = () => {
  return {
    potentialPayers: { data: [] },
    insurancePayors: { data: [] },
    addPotentialPayerStatus: false,
    updatePotentialPayerStatus: false,
  };
};
const state = initiateState();
const getters = {
  getPotentialPayers: (state) => state.potentialPayers,
  getInsurancePayors: (state) => state.insurancePayors,
  getAddPotentialPayerStatus: (state) => state.addPotentialPayerStatus,
  getUpdatePotentialPayerStatus: (state) => state.updatePotentialPayerStatus,
};
const mutations = {
  setPotentialPayers(state, data) {
    state.potentialPayers = data;
  },
  setInsurancePayors(state, data) {
    state.insurancePayors = data;
  },
  setAddPotentialPayerStatus(state, data) {
    state.addPotentialPayerStatus = data;
  },
  setUpdatePotentialPayerStatus(state, data) {
    state.updatePotentialPayerStatus = data;
  },
  reset: (state) => {
    const initial = initiateState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};
// Build a per-request config that overrides the ls-lab header with the
// explicitly selected lab (falls back to the axios-injected current lab).
const labConfig = (lab, extra = {}) =>
  lab ? { ...extra, headers: { "ls-lab": lab } } : { ...extra };

const actions = {
  // Potential payers for the selected lab.
  fetchPotentialPayers: async ({ commit, dispatch }, { params, lab } = {}) => {
    try {
      const response = await axios.get(
        "potential-payers",
        labConfig(lab, { params })
      );
      commit("setPotentialPayers", response.data);
    } catch (error) {
      commit("setPotentialPayers", { data: [] });
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
    }
  },

  // Master payor list from insurance_payors collection (for the add dropdown)
  fetchInsurancePayors: async ({ commit, dispatch }, params) => {
    try {
      const response = await axios.get("insurance-payors", { params });
      commit("setInsurancePayors", response.data);
    } catch (error) {
      commit("setInsurancePayors", { data: [] });
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
    }
  },

  addPotentialPayer: async ({ commit, dispatch }, { lab, ...payload }) => {
    try {
      commit("setAddPotentialPayerStatus", false);
      const response = await axios.post(
        "potential-payers",
        payload,
        labConfig(lab)
      );
      commit("setAddPotentialPayerStatus", response.data?.success || true);
      return response.data;
    } catch (error) {
      commit("setAddPotentialPayerStatus", false);
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
      throw error;
    }
  },

  updatePotentialPayerStatus: async (
    { commit, dispatch },
    { id, status, lab }
  ) => {
    try {
      commit("setUpdatePotentialPayerStatus", false);
      const response = await axios.patch(
        `potential-payers/${id}/status`,
        { status },
        labConfig(lab)
      );
      commit("setUpdatePotentialPayerStatus", response.data?.success || true);
      return response.data;
    } catch (error) {
      commit("setUpdatePotentialPayerStatus", false);
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
      throw error;
    }
  },
};
export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};
